import React, { useState, useCallback } from 'react'
import { Form, InputGroup, Button, Spinner } from 'react-bootstrap';
import FileApi from "../../api/files";
import { useDropzone } from "react-dropzone";

import ImageDisplay from '../ImageDisplay'

import './style.css'

const FileUpload = ({data, fileData, download, handleChange, disabled}) => {
	
	const [loading, setLoading] = useState(false);
	// const dropzoneRef = createRef();

	const onDrop = useCallback(files => handleChange({target: {name: data.nameForm, files: files}}), [data.nameForm, handleChange]);

	const {
    acceptedFiles,
    open,
    getRootProps,
    getInputProps
  } = useDropzone({
		onDrop,
    accept: data.accept,
		noClick: disabled,
  });

	const downloadFile = async () => {
		if (fileData) {
			setLoading(true);
			FileApi.download(fileData.id)
			.then(response => {
				const blobData = response.data;

				const url = window.URL.createObjectURL(blobData);

				// Cria um elemento <a> temporário
				const link = document.createElement('a');
				link.href = url;
				link.download = fileData.name;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				setLoading(false);
			}).catch(error => {
				console.error(`${error})`)
				setLoading(false);
			})
		}
	}

	return (
		<Form.Group className={data.class} controlId={data.nameForm}>
			<Form.Label>{data.name}</Form.Label>
			<InputGroup className="dropzone">
				<InputGroup {...getRootProps({className: 'dropzone w-auto'})}>
					<Button
						type="button"
						onClick={open}
						variant='basic'
						disabled={disabled}
						className='dropzone-button'
					>
						Escolher arquivo
					</Button>
					<input {...getInputProps()}/>
						<div
							className="dropzone-div"
							style={download ? {cursor: disabled ? 'auto' : 'pointer'} : { cursor: disabled ? 'not-allowed' : 'pointer', borderRadius: '0 var(--bs-border-radius) var(--bs-border-radius) 0'}}
							>
							{acceptedFiles.length > 0 ? 
								acceptedFiles[0].path :
									fileData?.name ? 
										fileData.name : "Nenhum arquivo escolhido"}
						</div>
				</InputGroup>
				{(download) && 
					<Button
						id="download-button"
						disabled={!fileData?.id || loading}
						onClick={downloadFile}
					>
						{loading ? 
							<Spinner
								as="span"
								animation="border"
								size="sm"
								role="status"
								aria-hidden="true"
							/> :
							<i className="bi bi-download"/>
						}
					</Button>
				}
			</InputGroup>
			{data.fileType === "image" && (acceptedFiles.length > 0 || fileData?.file) &&
				<ImageDisplay
					src={URL.createObjectURL(acceptedFiles[0] || fileData?.file)}
					alt={acceptedFiles[0]?.name || fileData?.name}
					style={data.style}
				/>
			}
		</Form.Group>
	)
}

export default FileUpload